module.exports = "/images/right.svg?130cedea1e90287ed7d9ccbc06536cb2";